import { createElement } from 'react';
import './index.scss';
import NoticeBarItem from './notice-bar-item';
import arr from '../../assets/icon/teletext-list/arr.png';
const NoticeBar = ({ dataList, onClick = () => { }, icon, children, handleMoreClick, moreText, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const stickyItems = (dataList || []).filter((item) => item?.isTop === 1);
    const loopItems = (dataList || []).filter((item) => item?.isTop === 0);
    return (createElement("div", { className: "notice-bar__panel", ..._otherProps },
        createElement("img", { className: "notice-bar__panel__item-img", src: icon, alt: "" }),
        createElement("div", { className: "notice-bar__panel__item-list" },
            stickyItems ? (stickyItems.map((item, index) => {
                return createElement(NoticeBarItem, { key: index, onClick: onClick, ...item }, children);
            })) : (createElement("div", null)),
            createElement("div", { className: "notice-bar__panel__item-loop" },
                createElement("div", null, loopItems.length > 0 ? (loopItems.map((item, index) => (createElement(NoticeBarItem, { key: index, onClick: onClick, ...item }, children)))) : (createElement("div", null, "No items to display"))))),
        createElement("div", { className: "notice-bar__panel__item-more" }, moreText
            ? (createElement("div", { className: "notice-bar__panel__item-more-more" },
                createElement("span", { className: "notice-bar__panel__item-more-more-text", onClick: handleMoreClick }, moreText),
                createElement("img", { src: arr, className: "notice-bar__panel__item-more-more-img" })))
            : '')));
};
NoticeBar.displayName = 'NoticeBar';
export default NoticeBar;
